<template>
  <div>
    <b-container fluid="sm" class="text-left">
      <div class="text-center" v-if="busy">
        <b-icon
          icon="three-dots"
          variant="success"
          animation="cylon"
          font-scale="6"
        ></b-icon>
      </div>
      <hr />
      <b-row v-if="show">
        <b-col cols="8">
          <b-form @submit="onSubmit" @reset="onReset" id="addcontractfrm">
            <b-form-group id="fg-1" label="Pacakge:" label-for="selectpack">
              <b-form-select
                id="selectpack"
                name="selectpack"
                v-model="form.contPackage"
                :options="packOpts"
                required
                v-on:change="displayPackBox()"
              ></b-form-select>
            </b-form-group>

            <b-form-group id="fg-2" label="Client:" label-for="selectclient">
              <b-form-select
                id="selectclient"
                name="selectclient"
                v-model="form.contClient"
                :options="clientOpts"
                required
                v-on:change="displayClientBox()"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              id="fg-3"
              label="Contract Start Date:"
              label-for="contStart"
            >
              <b-form-input
                id="contStart"
                name="contStart"
                type="date"
                v-model="form.contStart"
                required
                placeholder="DD/MM/YYYY"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="fg-4"
              label="Contract End Date:"
              label-for="contEnd"
            >
              <b-form-input
                id="contEnd"
                type="date"
                v-model="form.contEnd"
                readonly
                disabled
              ></b-form-input>
            </b-form-group>

            <b-form-group id="fg-5" label="Licence Key:" label-for="licencekey">
              <b-form-input
                id="licencekey"
                type="text"
                placeholder="Licence Key will generate by system and send to client via email"
                disabled
                readonly
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="fg-6"
              label="Payment Reference:"
              label-for="payref"
            >
              <b-form-input
                id="payref"
                name="payref"
                type="text"
                v-model="form.payref"
                placeholder="Please enter any payment reference"
              ></b-form-input>
            </b-form-group>

            <b-button type="submit" variant="primary" class="mr-1"
              >Submit</b-button
            >
            <b-button type="reset" variant="warning" id="resbtn">
              Reset
            </b-button>
          </b-form>
        </b-col>
        <b-col cols="4">
          <p>
            <b-card
              bg-variant="light"
              header="Package"
              class="text-center"
              :border-variant="form.packinfoColour"
            >
              <template v-if="form.packinfo">
                {{ form.packinfo.name }}<br />
                {{ form.packinfo.admins }} Admins<br />
                {{ form.packinfo.user }} Users<br />
                {{ form.packinfo.adis }} ADIs<br />
                {{ form.packinfo.contlength | monthf }} Contract<br />
                £{{ form.packinfo.initpay }} Initial Pay<br />
                Payment Frquency: {{ form.packinfo.payfreq | payfrqname }}<br />
              </template>
              <template v-else>
                <b-card-text>Please Select a Package</b-card-text>
              </template>
            </b-card>
          </p>
          <b-card
            bg-variant="light"
            header="Client"
            class="text-center"
            :border-variant="form.clientinfoColour"
          >
            <template v-if="form.clientinfo">
              <b-icon icon="building"></b-icon> {{ form.clientinfo.org }}<br />
              <b-icon icon="at"></b-icon> {{ form.clientinfo.orgemail }} <br />
              <b-icon icon="person-lines-fill"></b-icon>
              {{ form.clientinfo.person }} <br />
              <b-icon icon="telephone-fill"></b-icon>
              {{ form.clientinfo.persontel }} <br />
            </template>
            <template v-else>
              <b-card-text>Please Select a Client</b-card-text>
            </template>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ServerLinks from "../config.js";
import axios from "axios";

export default {
  data() {
    return {
      form: {
        contPackage: null,
        contClient: null,
        contStart: null,
        contEnd: null,
        payref: null,

        packinfo: null,
        packinfoColour: "danger",
        clientinfo: null,
        clientinfoColour: "danger"
      },

      packOpts: [{ text: "Select Package", value: null }],
      clientOpts: [{ text: "Select Client", value: null }],
      allPackages: [],
      allClients: [],
      show: false,
      busy: true
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.show = false;
      this.busy = true;

      let frm = document.getElementById("addcontractfrm");
      let fd = new FormData(frm);

      fd.append("addcontractfrm", "addcontractfrm");

      for (var pair of fd.entries()) {
        console.log(pair[0] + ", " + pair[1]);
      }

      axios
        .post(ServerLinks.SERVERCTRL, fd)
        .then(response => {
          let dt = response.data;
          console.log(dt);
          this.resolveReply(dt.result.code, dt.result.text);
        })
        .catch(error => {
          console.log(error);
          this.saveError("Non Syste error. " + error);
        })
        .finally(() => (this.busy = false));
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.packname = "";
      this.form.admins = 1;
      this.form.users = null;
      this.form.instructors = null;
      this.form.cntLength = 12;
      this.form.intpay = "";
      this.form.regpay = "";
      this.form.payfreq = 12;
      this.form.promocode = "";
      this.form.tandc = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    displayPackBox() {
      let elem = document.getElementById("selectpack").selectedIndex;
      console.log(elem);
      let index = elem - 1;
      this.form.packinfo = {
        name: this.allPackages[index].pack_name,
        admins: this.allPackages[index].max_admin,
        user: this.allPackages[index].max_users,
        adis: this.allPackages[index].max_adis,
        contlength: this.allPackages[index].contract_length,
        initpay: this.allPackages[index].init_payment,
        payfreq: this.allPackages[index].pay_freq
      };
      this.form.packinfoColour = "success";
    },
    displayClientBox() {
      let elem = document.getElementById("selectclient").selectedIndex;
      console.log(elem);
      let index = elem - 1;
      this.form.clientinfo = {
        org: this.allClients[index].org_name,
        orgemail: this.allClients[index].org_email,
        person:
          this.allClients[index].per_title +
          ". " +
          this.allClients[index].per_first_name +
          " " +
          this.allClients[index].per_last_name,
        persontel: this.allClients[index].per_tel
      };
      this.form.clientinfoColour = "success";
    },
    resolveReply(code, txt) {
      code = parseInt(code);
      if (code === 1) {
        this.saveSuccess();

        this.show = true;
        this.busy = false;
      } else {
        this.saveError(txt);
      }
    },
    saveSuccess() {
      this.$fire({
        title: "Create New Contract",
        text: "New Contract Added to system.",
        type: "success",
        timer: 6000
      }).then(r => {
        console.log(r);
        console.clear();
        this.$router.go();
      });
    },
    saveError(ermsg) {
      this.$fire({
        title: "Create New Contract Error",
        text:
          "There was an error adding new contract. Server Response:" + ermsg,
        type: "error"
        //timer: 6000
      });
    }
  },
  mounted() {
    //need to fill the data to right parts

    //load packages
    let packFD = new FormData();
    packFD.append("getpacakgesandclients", "getpacakgesandclients");

    axios
      .post(ServerLinks.SERVERCTRL, packFD)
      //.post(ServerLinks.SERVERCTRL, fd)
      .then(response => {
        let theDATA = response.data;
        let dt = theDATA.packages;
        this.allPackages = dt;
        console.log(dt);

        let cdt = theDATA.clients;
        console.log(cdt);
        this.allClients = cdt;

        ////this.resolveReply(dt.result.code, dt.result.text);
        for (let i = 0; i < dt.length; i++) {
          this.packOpts.push({
            text:
              dt[i].pack_id +
              " | " +
              dt[i].pack_name +
              " | " +
              dt[i].init_payment +
              " | " +
              dt[i].promo_code,
            value: dt[i].pack_id
          });
        }
        for (let i = 0; i < cdt.length; i++) {
          this.clientOpts.push({
            text:
              "ID " +
              cdt[i].org_id +
              " | " +
              cdt[i].org_name +
              " - " +
              cdt[i].org_add_city +
              " | " +
              cdt[i].per_title +
              ". " +
              cdt[i].per_first_name +
              " " +
              cdt[i].per_last_name,
            value: cdt[i].org_id
          });
        }
      })
      .catch(error => {
        console.log(error);
        //this.saveError("Non Syste error. " + error);
      })
      .finally(() => ((this.busy = false), (this.show = true)));
  }
};
</script>
